<template>
  <div id="timelineReview">
    <app-spinner v-if="offersLoading" />

    <v-container v-else-if="offers.length === 0">
      <h3 class="color light-gray text-center">
        No sway offers created. Contact <strong class="primary--text">team@localfluence.com</strong> to learn more about how to turn your current customers into
        social brand advocates.
      </h3>
    </v-container>

    <v-container v-else>
      <v-select
        v-model="selectedId"
        :loading="offersLoading"
        :disabled="offersLoading"
        :items="offerSelections"
        outlined
        item-text="title"
        item-value="id"
        label="Sway offers"
      />
      <h3 v-if="proofs.length === 0" class="text-center">No Proofs Yet</h3>
      <h4 v-else-if="selectedOfferType === 'WEB'">Please review and approve the proofs</h4>
      <div v-else-if="isGiveAwayOffer">
        <h4>Once the offer has expired please select and contact a winner</h4>
        <h6 class="caption font-weight-light text--secondary">{{ entriesLabel }}</h6>
      </div>

      <div class="grid-container mt-4">
        <template v-for="proof in proofs">
          <SwayOfferProofApprovalCard
            v-if="selectedOfferType === 'WEB'"
            :key="proof.id"
            :proof="proof"
            @sway-offer-approval-card-proof-reviewed="handleProofReviewed"
          />
          <SwayOfferWebGiveAwayCard v-else-if="isGiveAwayOffer" :key="proof.id" :proof="proof" />
          <div :key="`hack-spacer-${proof.id}`" style="width: 100%; height: 1px"></div>
        </template>
      </div>
    </v-container>
  </div>
</template>

<script>
import { ApiService } from '@/services/index'

import { isGiveAwayOffer } from '@/models/SwayOffer'

import SwayOfferProofApprovalCard from '@/components/SwayOffers/SwayOfferProofApprovalCard'
import SwayOfferWebGiveAwayCard from '@/components/SwayOffers/SwayOfferWebGiveAwayCard'

export default {
  name: 'Timeline',

  metaInfo: {
    title: 'Timeline Review',
  },

  components: {
    SwayOfferProofApprovalCard,
    SwayOfferWebGiveAwayCard,
  },

  data: () => ({
    proofs: [],
    proofsLoading: true,
    reviewLoading: false,
    offers: [],
    offersLoading: true,
    selectedId: null,
    selectedOfferType: null,
  }),

  computed: {
    entriesLabel() {
      return `${this.proofs.length} ${this.proofs.length === 1 ? 'entry' : 'entries'}`
    },
    offerSelections() {
      if (this.offersLoading || !this.offers) return
      return this.offers
        .filter((e) => e.offer_type !== 'LOCAL')
        .map((e) => {
          return {
            title: isGiveAwayOffer(e.offer_type) ? '' + e.offer_summary + ' - (expiration: ' + e.expiration_description + ')' : '' + e.offer_summary,
            id: e.id,
          }
        })
    },
    isGiveAwayOffer() {
      return isGiveAwayOffer(this.selectedOfferType)
    },
  },
  watch: {
    selectedId: function (event) {
      if (this.selectedId) {
        const selectedOffer = this.offers.find((e) => e.id === this.selectedId)
        this.selectedOfferType = selectedOffer.offer_type
        ApiService.get(`/swayOffer/proofsForOffer/${this.selectedId}`)
          .then((response) => {
            this.proofs = response.data
          })
          .finally(() => {
            this.proofsLoading = false
          })
      } else {
        this.proofsLoading = false
      }
    },
  },

  mounted() {
    ApiService.get(`/swayOffer`).then((response) => {
      this.offers = response.data
      this.offersLoading = false
      if (this.offers.length > 0) {
        this.selectedId = this.offers[0].id
        this.selectedOfferType = this.offers[0].offer_type
      }
    })
  },

  methods: {
    handleProofReviewed(proofId) {
      this.proofs.splice(
        this.proofs.findIndex((proof) => proof.id === proofId),
        1
      )
    },
  },
}
</script>

<style scoped lang="scss">
#timelineReview {
  width: 100%;
}
</style>
